let pathname = window.location.pathname;
let langs = ['/fr','/es','/it'];
let elems;
if (pathname.includes('/fr')) {
  elems = document.querySelectorAll('.template_fr');
} else if (pathname.includes('/it')) {
  elems = document.querySelectorAll('.template_it');
} else if (pathname.includes('/es')) {
  elems = document.querySelectorAll('.template_es');
} else {
  elems = document.querySelectorAll('.template_en');
}

// elems.forEach(item=>{
//   $(item).addClass('active')
// })

let isToggle;

function isMobile() {
  if (navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  }
  return false;
}

function IsAppleStore() {
  var u = navigator.userAgent;
  var ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  var iPad = u.indexOf('iPad') > -1;
  var iPhone = u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1;
  if ((ios || iPad || iPhone) && $(window).width() < 768) {
    return true;
  } else {
    return false;
  }
}



// 多语言切换
$('.tb-ind-lang-list .tb-ind-lang-item').click(function(){
    let currentLang = $(this).data('url');
    let prefix = pathname.substr(0,3);
    let origin = location.origin;
    let query = location.search;
    let suffix;
    if(currentLang.includes('turboant.com')){
      location.href = currentLang;
      return;
    }
    if(langs.includes(prefix)){
        suffix = pathname.substr(3)
    }else{
        suffix = pathname;
    }
    location.href = origin + (currentLang == '/' ? '' : currentLang) + suffix + query;
})


$(function () {
  let barStatus = sessionStorage.getItem('barStatus')
  if (barStatus == 1) {
    $('.tb-ind-bar').hide();
    $('.tb-product-tabs').removeClass('sticky')
  }
  $(window).width() <= 768 || isMobile() ? isToggle = true : isToggle = false;
})
$(window).resize(function () {
  if ($(window).width() >= 1024) {
    $('.tb-ind-menu-mobile').slideUp();
    $('.tb-ind-toggle').addClass('icon-menu').removeClass('icon-del')
  }
  $(window).width() <= 768 || isMobile() ? isToggle = true : isToggle = false;
});

$('.tb-ind-bar-close').click(function () {
  $('.tb-ind-bar').hide();
  $('.tb-product-tabs').removeClass('sticky')
  $('.tb-product-tabs-list').attr('data-barstatus', false)
  sessionStorage.setItem('barStatus', 1)
})

$("img.lazyload").lazyload();

// 头部导航切换
$('.tb-ind-toggle').click(function () {
  if ($(this).hasClass('icon-menu')) {
    $(this).removeClass('icon-menu').addClass('icon-del')
  } else {
    $(this).addClass('icon-menu').removeClass('icon-del')
  }
  $('.tb-ind-menu-mobile').slideToggle();
})

$('.tb-ind-menu-mobile-hd').click(function () {
  $(this).toggleClass('on');
  $(this).next().slideToggle();
  $(this).parent().siblings().find('.tb-ind-menu-mobile-hd').removeClass('on');
  $(this).parent().siblings().find('.tb-ind-menu-mobile-content').slideUp();
})

// 底部导航切换
$('.tb-ind-footer .tb-footer-nav-item dt').click(function (e) {
  if (isToggle) {
    $(this).parent('.tb-footer-nav-item').toggleClass('on');
    $(this).next().slideToggle();
    $(this).parent().siblings().removeClass('on');
    $(this).parent().siblings().find('dd').slideUp();
  }
});


// 搜索
$('.tb-ind-search-btn').click(function () {
  $('.tb-ind-menu').hide();
  $('.tb-ind-search').fadeIn();
  $('.tb-shade').show();
  $('#keyword').focus();
})

$('.tb-ind-search-close').click(function () {
  $('.tb-ind-search').hide();
  if ($(window).width() > 1024) {
    $('.tb-ind-menu').fadeIn();
  }
  $('.tb-shade').hide();
})

let pageKeyword = document.getElementById('pageKeyword')
$(document).keyup(function (e) {
  var key = e.which;
  if (key == 13 && $('#keyword').val() != '') {
    onNavSearch($('#keyword').val())
  }
  if (pageKeyword) {
    if (key == 13 && $('#pageKeyword').val() != '') {
      onNavSearch($('#pageKeyword').val())
    }
  }
});

$('.tb-ind-search .icon-search').click(function () {
  if ($('#keyword').val() != '') {
    onNavSearch($('#keyword').val())
  }
})

$('.page-search').click(function () {
  if ($('#pageKeyword').val() != '') {
    onNavSearch($('#pageKeyword').val())
  }
})


function onNavSearch(keyword) {
  let prefix = pathname.substr(0,3);
  let str;
  if(langs.includes(prefix)){
    str = langs.find(item=>{
      return item == prefix
    })
  }
  window.location.href = (str ? str : '') + '/search?q=' + keyword;
  $('#keyword').val('')
}


// 购物车弹窗
$('.tb-ind-cart').click(function () {
  $('.tb-shop-cart').addClass('show');
  $('.tb-shade').show();
  $('.tb-shade').addClass('zIndex')
})

$('.tb-shop-cart-close').click(function () {
  $('.tb-shop-cart').removeClass('show')
  $('.tb-shade').hide();
  $('.tb-shade').removeClass('zIndex')
})


$('.tb-shade').click(function () {
  $('.tb-shop-cart').hasClass('show') && $('.tb-shop-cart').removeClass('show')
  if (!$('.tb-ind-search').is(':hidden')) {
    $('.tb-ind-search').hide();
    $('.tb-ind-menu').show();
  }
  $(this).hide();
  $('.tb-shade').removeClass('zIndex')
  $('.subscriber-popup').fadeOut();
  $('.reward-botton').removeClass('hide-reward-botton');
})

$('.reward-botton').click(function() {
  $('.subscriber-popup').fadeIn();
  $('.reward-botton').addClass('hide-reward-botton');
  document.querySelector('.subscriber-popup') && $('.tb-shade').show();
});

$('.subscriber-close').click(function(){
  $('.subscriber-popup.all-page-discount-popup').hide();
  $('.reward-botton').removeClass('hide-reward-botton');
  $('.tb-shade').hide();
})

// 返回顶部
$(window).scroll(function () {
  let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  if (scrollTop > 900) {
    $('.tb-go-top').fadeIn();
    isMobile() && $('.tb-product-fixed').css('display','flex')
  } else {
    $('.tb-go-top').fadeOut();
    isMobile() && $('.tb-product-fixed').css('display','none')
  }
})
$('.tb-go-top').click(function () {
  $('body,html').animate({
    scrollTop: 0
  }, 300)
})


// 视频播放
let youtubeVideo = document.getElementById('youtubeVideo')
$('.tb-video-play').click(function () {
  let video = $(this).parent().data('url');
  $('.tb-video-window').show();
  $('body').addClass('over-hidden');
  youtubeVideo.setAttribute('src', video + '?autoplay=1')
})
$('.tb-video-close').click(function () {
  $('body').addClass('over-auto');
  $('.tb-video-window').hide();
  youtubeVideo.setAttribute('src', '')
})




/**
 * 获取购物车数据
 */

function getCartData() {
  fetch(window.Shopify.routes.root + 'cart.js').then(res => {
      return res.json()
    })
    .then(res => {
      updateCart(res)
      toggleCart('add')
      // loading.classList.remove('active');
    })
}

/**
 * 切换购物车产品数量
 */

function changeCart(type, id, index,mode) {
  let cartProductNum = document.getElementById(`cartProductNum-${index}`);
  let cartTableNum = document.getElementById(`cartTableNum-${index}`);
  let num = parseInt(cartProductNum.value)
  if (type == 'min') {
    num >= 0 && (num--);
  } else if (type == 'add') {
    num++;
  } else if(type == 'change'){
    mode == 'table' ? num = parseInt(cartTableNum.value) : parseInt(cartProductNum.value)
  }else{
    num = 0;
  }
  cartProductNum.value = num;
  cartTableNum && (cartTableNum.value = num);
  $.ajax({
    url: window.Shopify.routes.root + 'cart/change.js',
    type: 'post',
    data: {
      id: parseInt(id),
      quantity: num
    },
    dataType: 'json',
    success: (res) => {
      updateCart(res);
    }
  })
}

/**
 * 更新购物车模板
 */

function updateCart(res) {
  const {
    items,
    total_price,
    item_count,
    currency
  } = res;
  let cartList = document.querySelector('.tb-shop-cart-list'); //购物车列表
  let cartTable = document.querySelector('.tb-cart-data tbody'); //购物车表格
  let cartTableTotal = document.querySelector('.cart-table-total'); //购物车总价格
  let cartTotal = document.querySelector('.tb-shop-cart-total-price'); //购物车弹窗总价格
  let cartContent = document.querySelector('.tb-shop-cart-content');
  let cartTableWrap = document.querySelector('.cart-table-form');
  let cartEmpty = document.querySelector('.tb-shop-cart-empty');
  let cartTableEmpty = document.querySelector('.cart-table-empty');
  let hdCartTotal = document.querySelector('.tb-ind-cart-badge');
  let tr = "";
  let li = "";
  items.forEach((item, i) => {
    li += `<li class="tb-shop-cart-item">
    <a href="tb-shop-cart-cover">
      <img src="${item.image}" alt="">
    </a>
    <div class="tb-shop-cart-info">
      <div class="tb-shop-cart-name"><a href="${item.url}">${item.title}</a> <i
          class="iconfont icon-shanchu" onclick="changeCart('remove',${item.id},${i + 1})"></i></div>
      <p>
        <span class="tb-shop-cart-price">${formatMoney(item.final_price,currency)}</span>
        <s class="tb-shop-cart-original">${item.final_price != item.original_price ? formatMoney(item.original_price,currency) : ''}</s>
      </p>
      <div class="tb-shop-cart-stepper">
        <i class="iconfont icon-reduce" onclick="changeCart('min',${item.id},${i + 1})"></i>
        <input id="cartProductNum-${i + 1}" class="tb-shop-cart-qty" type="number" onchange="changeCart('change',${item.id},${i + 1})"  min="1" value="${item.quantity}"  name="updates[]">
        <i class="iconfont icon-add" onclick="changeCart('add',${item.id},${i + 1})"></i>
      </div>
    </div>
    </li>`
    tr += ` <tr>
          <td>
            <a class="cart-product-info" href="${item.url}">
              <img src="${item.image}" alt="${item.title}">
              <dl>
                <dt class="cart-product-name">${item.title}</dt>
                <dd class="cart-product-style">${item.variant_title ? item.variant_title : ''}</dd>
              </dl>
            </a>
          </td>
          <td>
            <p class="cart-current-price">${formatMoney(item.price,currency)}</p>
            <p class="cart-original-price">${item.original_price !== item.price ? formatMoney(item.original_price,currency) : ''}</p>
            ${item.message ? `<p class="cart-sale-msg"><i class="iconfont icon-icon_discount1"></i>${item.message}</p>`: ''}
          </td>
          <td>
            <div class="cart-qty-box">
              <i class="iconfont icon-reduce" onclick="changeCart('min',${item.id},${i + 1})"></i>
              <input class="cart-qty-num" id="cartTableNum-${i + 1}" onchange="changeCart('change',${item.id},${i + 1},'table')" type="number" name="updates[]" id="updates_{{ item.key }}" value="${item.quantity}" min="1">
              <i class="iconfont icon-add" onclick="changeCart('add',${item.id},${i + 1})"></i>
            </div>
          </td>
          <td class="cart-product-total">
            <i class="iconfont icon-del" onclick="changeCart('remove',${item.id},${i + 1})"></i>
            <p>
              <span>${formatMoney(item.line_price,currency)}</span>
              <s>${item.original_line_price != item.line_price ? formatMoney(item.original_line_price,currency) : ''}</s>
            </p>
            </td>
        </tr>`
  })
  cartList.innerHTML = li;
  cartTable && (cartTable.innerHTML = tr);
  cartTableTotal && (cartTableTotal.innerHTML = formatMoney(total_price, currency))
  cartTotal.innerHTML = formatMoney(total_price, currency);
  hdCartTotal.innerHTML = item_count;
  if (item_count == 0) {
    cartContent && cartContent.classList.add('hide');
    cartEmpty && cartEmpty.classList.remove('hide');
    if (cartTable) {
      cartTableWrap && cartTableWrap.classList.add('hide');
      cartTableEmpty && cartTableEmpty.classList.remove('hide');
    }
  } else {
    cartContent && cartContent.classList.remove('hide');
    cartEmpty && cartEmpty.classList.add('hide');
    if (cartTable) {
      cartTableWrap && cartTableWrap.classList.remove('hide');
      cartTableEmpty && cartTableEmpty.classList.add('hide');
    }
  }
}



/**
 * 价格格式转换
 */
function formatMoney(cents, currency, format) {
  let moneyFormat;
  if (currency == 'EUR') {
    moneyFormat = '€{{amount}}'
  } else if (currency == 'GBP') {
    moneyFormat = '£{{amount}}'
  } else {
    moneyFormat = '${{amount}}'
  }
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || '.';
    decimal = decimal || ',';

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}


/**
 * 渠道转化区分功能开始
 */
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + "; " + expires + ";domain=.turboant.com;path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return '';
}
var tmp_src = getQueryVariable('utm_source');
if (!tmp_src) {
  tmp_src = getQueryVariable('source');
  if (!tmp_src) {
    tmp_src = getQueryVariable('avad');
    if (tmp_src) {
      tmp_src = 'avantlink';
    }
  }
}
//console.log(tmp_src);
if (!tmp_src) {
  tmp_src = 'other';
}
if (tmp_src && !getCookie('_turboant_src_my')) {
  setCookie('_turboant_src_my', tmp_src, 30);
}


//google facebook追踪add to cart事件
$("#addCart").click(function () {
 
  gtag('event', 'conversion', {
    'send_to': 'AW-336621279/hDLUCKGguqIYEN_dwaAB'
  });
  console.log('2222222');
  let currency = Shopify.currency.active;
  let product_id = document.querySelector("#productPage").getAttribute('data-id');
  let product_name = document.querySelector("h1.tb-product-name").innerHTML;
  //console.log(Shopify.currency.active);
  gtag("event", "add_to_cart", {
    currency: currency,
    value: 2,
    items: [
      {
        item_id: product_id,
        item_name: product_name,
        currency: currency,
        index: 0,
        price: 2,
        quantity: 1
      }
    ]
  });
  

});


/**
 * 渠道转化区分功能结束
 */


//google facebook追踪发起结账事件
$(".shopify-payment-button").click(function () {
  //console.log('123');
  gtag('event', 'conversion', {'send_to': 'AW-336621279/hfB3CNbq4KIYEN_dwaAB'});
  doFbInitiateCheckoutOp();
  
});
$(".tb-shop-cart-submit").click(function () {
  gtag('event', 'conversion', {'send_to': 'AW-336621279/hfB3CNbq4KIYEN_dwaAB'});
  doFbInitiateCheckoutOp();
});

$('.shopify-currency-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});

$('.shopify-localization-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
})

// 订阅弹窗 start-----
let subscriberStatus = sessionStorage.getItem('subscriberStatus')
let popupTime = parseInt($('.subscriber-popup').data('time') + '000')
if ($('.subscriber-popup').hasClass('index') || $('.subscriber-popup').hasClass('product')) {
  if(!subscriberStatus){
    setTimeout(()=>{
      $('.subscriber-popup').fadeIn();
      document.querySelector('.subscriber-popup') && $('.tb-shade').show();
    },popupTime)
  }
}



$('.subscriber-close').click(function(){
  sessionStorage.setItem('subscriberStatus',1)
  $('.subscriber-popup').hide();
  $('.tb-shade').hide();
})

// 订阅提交
$("#subscriberForm").submit(function (e) {
  e.preventDefault();
  // 此处为请求
  $.ajax({
    url: 'https://backend.turboant.com/index/api/dealshopifycustomer',
    type: 'post',
    data: {
      account:'eu-turboant.myshopify.com',
      email: $('.subscriber-email').val()
    },
    dataType: 'json',
    success: (res) => {
        const { status, msg } = res;
        if(status === 1){
          $('.subscriber-form').hide();
          $('.subscriber-result').show();
          $('.subscriber-popup').append(`<div class='tb-toast'>Subscribe to the success!</div>`);
          setTimeout(function () {
            $('.tb-toast').remove();
          }, 1000)
        }else{
          $('.subscriber-popup').append(`<div class='tb-toast'>${msg}</div>`);
          setTimeout(function () {
            $('.tb-toast').remove();
          }, 1000)
        }
    }
  });
  
  //请求成功后操作(换成接口后此处可以删除)
  // $('.subscriber-form').hide();
  // $('.subscriber-result').show();
});


// 订阅复制折扣码
let subscriberCopy = document.querySelectorAll('.subscriber-code');
let subscriberClipboard = new Clipboard(subscriberCopy);
subscriberClipboard.on('success', function (e) {
  let successCon = "<div class='tb-toast'>Successfully copied!  </div>"
  $('.subscriber-popup').append(successCon);
  setTimeout(function () {
    $('.tb-toast').remove();
  }, 1000)
});

// 订阅弹窗 end-----

// 顶部通知轮播
var indBarSwiper = new Swiper('.indBarSwiper', {
  slidesPerView: 1,
  spaceBetween: 24,
  autoplay:true,
  loop: true,
});